import { useEffect, useState } from 'react';
import { CheckCircle2, Download, LockKeyhole, ShieldCheck, XCircle } from 'lucide-react';
import { useParams } from 'react-router-dom';
import { api } from '../lib/api';

const readable=value=>String(value||'').replaceAll('_',' ').replace(/\b\w/g,m=>m.toUpperCase());

export default function DSRSecureDelivery(){
  const{token}=useParams();
  const[data,setData]=useState(null),[error,setError]=useState(''),[busy,setBusy]=useState(false);
  const load=async()=>{
    setError('');
    try{setData(await api('/api/public/data-protection/delivery/'+encodeURIComponent(token||'')));}
    catch(e){setError(e.message||'This secure delivery could not be opened.');}
  };
  useEffect(()=>{void load()},[token]);

  const download=async()=>{
    setBusy(true);setError('');
    try{
      const response=await fetch('/api/public/data-protection/delivery/'+encodeURIComponent(token||'')+'/download',{credentials:'omit',cache:'no-store'});
      if(!response.ok){let body={};try{body=await response.json()}catch{}throw new Error(body.message||'The disclosure could not be downloaded.')}
      const blob=await response.blob(),disposition=response.headers.get('content-disposition')||'',fileName=disposition.match(/filename="?([^";]+)"?/i)?.[1]||'Sousa-Murray-Data-Protection.zip';
      const url=URL.createObjectURL(blob),a=document.createElement('a');a.href=url;a.download=fileName;document.body.appendChild(a);a.click();a.remove();URL.revokeObjectURL(url);
      await load();
    }catch(e){setError(e.message||'The disclosure could not be downloaded.')}
    finally{setBusy(false)}
  };

  if(error&&!data)return <Shell><Result icon={XCircle} tone="bad" title="Secure delivery unavailable" body={error}/></Shell>;
  if(!data)return <Shell><Result icon={ShieldCheck} tone="neutral" title="Opening secure delivery" body="Checking the disclosure link and download permissions…"/></Shell>;

  if(!data.available)return <Shell><Result icon={data.status==='exhausted'?CheckCircle2:XCircle} tone={data.status==='exhausted'?'good':'bad'} title={data.status==='exhausted'?'Disclosure download completed':'This secure link is no longer active'} body={data.status==='exhausted'?'The permitted downloads for this disclosure have been used. Contact Data Protection if you need the link reissued.':'The link may have expired or been replaced. Contact Data Protection and quote the reference below.'} reference={data.reference}/></Shell>;

  return <Shell>
    <section className="dsrd-card">
      <div className="dsrd-icon"><ShieldCheck size={30}/></div>
      <span className="dsrd-kicker">SECURE DATA PROTECTION DELIVERY</span>
      <h1 className="govuk-heading-xl">Your disclosure is ready</h1>
      <p className="govuk-body">The approved response for Data Protection request <strong>{data.reference}</strong> is ready to download securely.</p>
      <div className="dsrd-facts">
        <div><span>Request</span><strong>{readable(data.request_type)}</strong></div>
        <div><span>Link expires</span><strong>{new Date(data.expires_at).toLocaleString('en-GB')}</strong></div>
        <div><span>Downloads</span><strong>{data.download_count} of {data.max_downloads}</strong></div>
      </div>
      {error&&<div className="dsrd-error">{error}</div>}
      <button onClick={download} disabled={busy}><Download size={17}/>{busy?'Preparing secure download…':'Download disclosure package'}</button>
      <div className="dsrd-security"><LockKeyhole size={15}/><span>This page uses an expiring bearer link sent to the verified requester address. The package is rebuilt from the frozen approved files and integrity-checked before every download.</span></div>
    </section>
  </Shell>;
}

function Result({icon:Icon,tone,title,body,reference}){
  return <section className={'dsrd-card dsrd-result '+tone}><Icon size={34}/><span className="dsrd-kicker">SOUSA MURRAY · DATA PROTECTION</span><h1 className="govuk-heading-xl">{title}</h1><p className="govuk-body">{body}</p>{reference&&<strong className="dsrd-reference">Reference {reference}</strong>}</section>;
}
function Shell({children}){
  return <main className="dsrd-page">
    <header className="dsrd-header"><div><ShieldCheck size={21}/><span><strong>SOUSA MURRAY</strong><small>DATA PROTECTION · SECURE DELIVERY</small></span></div><em><LockKeyhole size={13}/>Expiring portal</em></header>
    <div className="dsrd-content">{children}</div>
    <footer className="dsrd-footer">Sousa Murray Group Ltd · Secure Data Protection delivery</footer>
  </main>;
}
